import React, { useMemo } from "react";
import { useDispatch } from "react-redux";
import ProductCard from "../../../modules/ui/ProductCard";
import {
  DELETE_PRODUCT_MY_ORDER,
  MAKE_ORDER,
} from "../../../store/Products/Products.constant";
import { MODAL_CHANGE_ORDER } from "../../../store/Modal/Modal.constant";
import "./style.scss";

const MyOrder = ({
  joined_member_count,
  head_count,
  currency,
  products,
  settings,
  isJoin,
  slug_uuid,
  balanceTopUpAmount,
  group_order_member,
  hideEdit,
}) => {
  const {
    member_id,
    group_order_id,
    id: group_order_member_id,
  } = group_order_member || {};
  const totalAmount = balanceTopUpAmount + settings?.budget || 0;
  const myProducts = useMemo(() => {
    return products?.myProducts ?? [];
  }, [products]);

  const dispatch = useDispatch();
  let total = 0;
  myProducts.map((item) => (total += +item.total_price_cents));
  const clearCart = () => {
    myProducts.forEach((item) => {
      dispatch({
        type: DELETE_PRODUCT_MY_ORDER,
        payload: { data: item.id, user_id: slug_uuid },
      });
    });
  };
  const compilingProductToOrder = (myProducts, auth) => {
    let group_order_items = [];
    myProducts.forEach((item) => {
      let quantity = 0;
      let newMappings = {};
      Object.keys(item.menu_items_mapping).forEach((key) => {
        quantity += item.menu_items_mapping[key].quantity;
        if (item.menu_items_mapping[key].quantity !== 0) {
          newMappings[key] = item.menu_items_mapping[key];
        }
      });
      group_order_items.push({
        group_order_member_id: member_id,
        group_order_id,
        menu_id: item.id,
        menu_price: item.price_cents,
        quantity: item.quantity || quantity,
        menu_item_mappings: newMappings,
        sub_total: item.total_price_cents,
        special_instruction: item.special_instruction,
      });
    });
    return group_order_items;
  };

  let change = false;
  (myProducts?.length !== products?.oldMyOrder?.length ||
    JSON.stringify(products?.myProductsId) !==
      JSON.stringify(products?.oldMyOrderId)) &&
    (change = true);
  !change &&
    myProducts.map((item) => {
      products.oldMyOrder.map((oldItem) => {
        if (item.id === oldItem.menu_id) {
          if (item.menu_items.length) {
            JSON.stringify(item.menu_items_mapping) !==
              JSON.stringify(oldItem.menu_item_mappings) && (change = true);
          } else {
            item.quantity !== oldItem.quantity && (change = true);
          }
        }
        return null;
      });
      return null;
    });

  let itemCount = 0;
  myProducts.forEach((item) => {
    if (item.menu_items?.length) {
      Object.values(item.menu_items_mapping || {}).forEach(
        (mapping) => (itemCount += +mapping.quantity)
      );
    } else {
      itemCount += item.quantity || 1;
    }
  });
  const youPayCents = Math.max(0, -totalAmount);
  const companyPortionCents = Math.max(0, total - youPayCents);
  const formatMoney = (cents) => currency + (cents / 100).toFixed(2);

  const submitOrder = () => {
    dispatch({
      type: MAKE_ORDER,
      payload: {
        id: group_order_id,
        group_order_items: compilingProductToOrder(
          myProducts,
          settings.auth
        ),
        path_rerender: slug_uuid,
        user_id: settings.auth.id,
        modalOpen: true,
        group_order_member_id,
      },
    });
  };

  if (!hideEdit) {
    return (
      <div className="ordered__cart">
        <div className="container">
          {myProducts?.length ? (
            <div className="cart-bar">
              <div className="cart-bar__summary">
                <span className="cart-bar__icon" aria-hidden="true">
                  🧾
                </span>
                <div className="cart-bar__info">
                  <p className="cart-bar__title">
                    {itemCount} item{itemCount === 1 ? "" : "s"} Selected
                    <span>{formatMoney(total)}</span>
                  </p>
                  <p className="cart-bar__subtitle">
                    Company portion {formatMoney(companyPortionCents)} • You pay
                    today {formatMoney(youPayCents)}
                  </p>
                </div>
              </div>
              <div className="cart-bar__actions">
                {products?.oldMyOrderId?.length ? (
                  <>
                    <button
                      className="cart-bar__clear"
                      type="button"
                      onClick={() => {
                        dispatch({
                          type: MODAL_CHANGE_ORDER,
                          payload: {
                            slug: "isModalChangeOrder",
                            user_id: slug_uuid,
                            info: {
                              method: "DELETE",
                              content: {
                                id: group_order_id,
                                group_order_items: products?.oldMyOrder,
                                path_rerender: slug_uuid,
                                user_id: settings.auth.id,
                              },
                            },
                          },
                        });
                      }}
                    >
                      Cancel Order
                    </button>
                    {change ? (
                      <button
                        className="cart-bar__confirm"
                        type="button"
                        onClick={() => {
                          dispatch({
                            type: MODAL_CHANGE_ORDER,
                            payload: {
                              slug: "isModalChangeOrder",
                              user_id: slug_uuid,
                              info: {
                                method: "UPDATE",
                                content: {
                                  id: group_order_id,
                                  group_order_items: compilingProductToOrder(
                                    myProducts,
                                    settings.auth
                                  ),
                                  path_rerender: slug_uuid,
                                  user_id: settings.auth.id,
                                  modalOpen: false,
                                },
                              },
                            },
                          });
                        }}
                      >
                        Update Order
                      </button>
                    ) : null}
                  </>
                ) : (
                  <>
                    <button
                      className="cart-bar__clear"
                      type="button"
                      onClick={clearCart}
                    >
                      Clear
                    </button>
                    <button
                      className="cart-bar__confirm"
                      disabled={joined_member_count >= head_count}
                      onClick={submitOrder}
                      type="button"
                    >
                      <span role="img" aria-hidden="true">🐼</span> Review &amp;
                      Confirm Order
                    </button>
                  </>
                )}
              </div>
            </div>
          ) : null}
          {!products?.oldMyOrderId?.length &&
          myProducts?.length &&
          joined_member_count >= head_count ? (
            <div className="ordered__error">
              The maximum headcount for this order has been reached. Please
              contact your company's food co-ordinator to inquire
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  return (
    <div className="ordered__cart">
      <div className="container">
        {myProducts?.length ? (
          <div className="outer__ordered--cart">
            <h2>
              {hideEdit ? "Here's what you've ordered" : "My Order"}
              <span className="items-selected-badge">
                {myProducts.length} item{myProducts.length === 1 ? "" : "s"} selected
              </span>
            </h2>
            <div className="list__ordered">
              <div className="ordered__container">
                {myProducts?.map((item, index) => (
                  <ProductCard
                    disabledSelect={hideEdit}
                    user_id={slug_uuid}
                    modalProductFlag={"CHANGE"}
                    isJoin={isJoin}
                    currency={currency}
                    myProductsId={products?.myProductsId}
                    oldMyOrderId={products?.oldMyOrderId}
                    key={index}
                    product={item}
                    className="active__full"
                  />
                ))}
              </div>
              <div className="ordered__button">
                <span>Total</span>
                <h6>{currency + (+total / 100).toFixed(2)}</h6>
                {!hideEdit &&
                  (products?.oldMyOrderId?.length ? (
                    <>
                      {change ? (
                        <button
                          onClick={() => {
                            dispatch({
                              type: MODAL_CHANGE_ORDER,
                              payload: {
                                slug: "isModalChangeOrder",
                                user_id: slug_uuid,
                                info: {
                                  method: "UPDATE",
                                  content: {
                                    id: group_order_id,
                                    group_order_items: compilingProductToOrder(
                                      myProducts,
                                      settings.auth
                                    ),
                                    path_rerender: slug_uuid,
                                    user_id: settings.auth.id,
                                    modalOpen: false,
                                  },
                                },
                              },
                            });
                          }}
                          type="button"
                        >
                          Update Order
                        </button>
                      ) : null}
                      <button
                        onClick={() => {
                          dispatch({
                            type: MODAL_CHANGE_ORDER,
                            payload: {
                              slug: "isModalChangeOrder",
                              user_id: slug_uuid,
                              info: {
                                method: "DELETE",
                                content: {
                                  id: group_order_id,
                                  group_order_items: products?.oldMyOrder,
                                  path_rerender: slug_uuid,
                                  user_id: settings.auth.id,
                                },
                              },
                            },
                          });
                        }}
                        type="button"
                      >
                        Cancel Order
                      </button>
                    </>
                  ) : (
                    <>
                    <button
                      className="clear-cart-btn"
                      type="button"
                      onClick={clearCart}
                    >
                      Clear
                    </button>
                    <button
                      disabled={joined_member_count >= head_count}
                      onClick={() => {
                        dispatch({
                          type: MAKE_ORDER,
                          payload: {
                            id: group_order_id,
                            group_order_items: compilingProductToOrder(
                              myProducts,
                              settings.auth
                            ),
                            path_rerender: slug_uuid,
                            user_id: settings.auth.id,
                            modalOpen: true,
                            group_order_member_id,
                          },
                        });
                        // totalAmount < 0 ? dispatch({ type: OPEN_MODAL_BUDGET_ALLOCATED, payload: slug_uuid })
                        //     :
                        //     dispatch({
                        //         type: MAKE_ORDER, payload: {
                        //             id: group_order_id,
                        //             group_order_items: compilingProductToOrder(myProducts, settings.auth),
                        //             path_rerender: slug_uuid,
                        //             user_id: settings.auth.id,
                        //             modalOpen: true,
                        //         }
                        //     })
                      }}
                      type="button"
                    >
                      Submit Order
                    </button>
                    </>
                  ))}
                {!products?.oldMyOrderId?.length &&
                joined_member_count >= head_count ? (
                  <div className="ordered__error">
                    The maximum headcount for this order has been reached.
                    Please contact your company's food co-ordinator to inquire
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        ) : (
          hideEdit && (
            <h3
              style={{
                marginTop: "60px",
                marginBottom: "60px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              It looks like you didn't order anything for this day!
            </h3>
          )
        )}
      </div>
    </div>
  );
};
export default MyOrder;
